// material-ui
import { createTheme, ThemeOptions } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

type Mode = 'light' | 'dark';

export default function Palette(mode: Mode, presetColor: string): any {
  const colors = presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors) as any;

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      // base palette from preset
      ...paletteColor,
      // overrides with provided brand colors
      primary: {
        ...(paletteColor as any).primary,
        main: '#0BA26F',
        light: '#4FD7A9',
        dark: '#01392C',
        contrastText: '#FFFFFF'
      },
      secondary: {
        ...(paletteColor as any).secondary,
        main: '#01392C',
        light: '#FFFCF9',
        dark: '#0A0A0A',
        contrastText: '#FFFFFF'
      },
      success: {
        ...(paletteColor as any).success,
        light: '#4FD7A9',
        main: '#0BA26F',
        dark: '#01392C',
        contrastText: '#FFFFFF'
      },
      info: {
        ...(paletteColor as any).info,
        light: '#FFFCF9',
        main: '#01392C',
        dark: '#0A0A0A',
        contrastText: '#FFFFFF'
      },
      text: {
        primary: mode === 'light' ? '#0A0A0A' : '#FFFFFF',
        secondary: mode === 'light' ? '#01392C' : '#FFFCF9',
        disabled: paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: paletteColor.grey[200],
      background: {
        paper: mode === 'light' ? '#FFFCF9' : '#0A0A0A',
        default: mode === 'light' ? '#FFFCF9' : '#0A0A0A'
      }
    }
  });
}
